import styled from 'styled-components'

export const MediaImageStyled = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: block;
  background-position: center center;
  background-size: cover;
  background-color: transparent;
`
